module.exports = __webpack_public_path__ + "static/services-background-8eaac74e73dbb67596accff5a8b94cad.jpg";